export const censusGraphs = () => {
  return [
    {
      label: 'Socio-economics & Demographics Comparisons',
      type: 'TITLE',
      excludeFromLimited: true,
      newPage: true,
    },
    {
      title: 'Median Household Income',
      graph: 'med_hh_inc_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'med_hh_inc_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_hh_inc_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_hh_inc_single_fips_state',
        },
      ],
    },
    {
      title: 'Poverty Rate',
      graph: 'pov_pct_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'pov_pct_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'pov_pct_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'pov_pct_single_fips_state',
        },
      ],
    },
    {
      title: "Bachelor's Degree Holder Rate",
      graph: 'ed_ba_plus_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'ed_ba_plus_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_ba_plus_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_ba_plus_single_fips_state',
        },
      ],
    },
    {
      title: 'Median Rent',
      graph: 'med_rent_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'med_rent_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_rent_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_rent_single_fips_state',
        },
      ],
    },
    {
      title: 'Households with Children Under 18',
      graph: 'hh_w_kids_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'hh_w_kids_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hh_w_kids_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hh_w_kids_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population White',
      graph: 'rc_white_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_white_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_white_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_white_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Black or African American',
      graph: 'rc_afam_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_afam_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_afam_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_afam_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population American Indian or Alaska Native',
      graph: 'rc_natv_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_natv_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_natv_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_natv_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Asian',
      graph: 'rc_asian_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_asian_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_asian_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_asian_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Native Hawaiian or Other Pacific Islander',
      graph: 'rc_islnd_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_islnd_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_islnd_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_islnd_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Other Race',
      graph: 'rc_other_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_other_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_other_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_other_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Two or More Races',
      graph: 'rc_2p_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'rc_2p_single_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_2p_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_2p_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Hispanic or Latino (of any race)',
      graph: 'hispanic_latino_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hispanic_latino_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hispanic_latino_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hispanic_latino_us',
        },
      ],
    },
    {
      title: 'Households with Computer Access',
      graph: 'hh_w_comp_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'CITY',
          useFilters: true,
          graph: 'hh_w_comp_fips_cousub',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hh_w_comp_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hh_w_comp_fips_state',
        },
      ],
    },
  ];
};

export const countyCensusGraphs = () => {
  return [
    {
      label: 'Socio-economics & Demographics Comparisons',
      type: 'TITLE',
      excludeFromLimited: true,
      newPage: true,
    },
    {
      title: 'Median Household Income',
      graph: 'med_hh_inc_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_hh_inc_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_hh_inc_single_fips_state',
        },
      ],
    },
    {
      title: 'Poverty Rate',
      graph: 'pov_pct_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'pov_pct_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'pov_pct_single_fips_state',
        },
      ],
    },
    {
      title: "Bachelor's Degree Holder Rate",
      graph: 'ed_ba_plus_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_ba_plus_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_ba_plus_single_fips_state',
        },
      ],
    },
    {
      title: 'Median Rent',
      graph: 'med_rent_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_rent_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_rent_single_fips_state',
        },
      ],
    },
    {
      title: 'Households with Children Under 18',
      graph: 'hh_w_kids_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hh_w_kids_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hh_w_kids_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population White',
      graph: 'rc_white_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_white_single_fips_state',
        },
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_white_single_fips_county',
        },
      ],
    },
    {
      title: '% of Population Black or African American',
      graph: 'rc_afam_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_afam_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_afam_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population American Indian or Alaska Native',
      graph: 'rc_natv_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_natv_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_natv_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Asian',
      graph: 'rc_asian_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_asian_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_asian_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Native Hawaiian or Other Pacific Islander',
      graph: 'rc_islnd_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_islnd_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_islnd_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Other Race',
      graph: 'rc_other_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_other_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_other_single_fips_state',
        },
      ],
    },
    {
      title: '% of Population Two or More Races',
      graph: 'rc_2p_single_fips_bg',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_2p_single_fips_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_2p_single_fips_state',
        },
      ],
    },
  ];
};

export const censusGraphsPlaceImpact = ({ prepend, exclude = [] } = {}) => {
  return [
    {
      label: 'Housing & Real Estate Comparisons',
      type: 'TITLE',
      newPage: true,
    },
    {
      label: 'Census Comparison',
      type: 'CENSUS_COMPARISON_TABLE',
      table: 'place_impact_housing_census_table',
      prepend,
    },
    {
      title: 'Housing Affordability',
      graph: 'housing_affordability_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Index Value',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'housing_affordability_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'housing_affordability_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'housing_affordability_us',
        },
      ],
    },
    // {
    //   title: 'Housing Affordability - Renters',
    //   graph: 'housing_affordability_renters_fips',
    //   type: 'COMPARISON_LINE_GRAPH',
    //   useRatio: false,
    //   after: 2011,
    //   label: 'Block Group',
    //   unit: 'Index Value',
    //   compare: [
    //     {
    //       to: 'COUNTY',
    //       useFilters: true,
    //       graph: 'housing_affordability_renters_concat_state_county',
    //     },
    //     {
    //       to: 'STATE',
    //       useFilters: true,
    //       graph: 'housing_affordability_renters_state',
    //     },
    //     {
    //       to: 'COUNTRY',
    //       label: 'USA',
    //       useFilters: true,
    //       graph: 'housing_affordability_renters_us',
    //     },
    //   ],
    // },
    // {
    //   title: 'Housing Affordability - Owners',
    //   graph: 'housing_affordability_owners_fips',
    //   type: 'COMPARISON_LINE_GRAPH',
    //   useRatio: false,
    //   after: 2011,
    //   label: 'Block Group',
    //   unit: 'Index Value',
    //   compare: [
    //     {
    //       to: 'COUNTY',
    //       useFilters: true,
    //       graph: 'housing_affordability_owners_concat_state_county',
    //     },
    //     {
    //       to: 'STATE',
    //       useFilters: true,
    //       graph: 'housing_affordability_owners_state',
    //     },
    //     {
    //       to: 'COUNTRY',
    //       label: 'USA',
    //       useFilters: true,
    //       graph: 'housing_affordability_owners_us',
    //     },
    //   ],
    // },
    {
      title: 'Median Rent',
      graph: 'med_rent_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_rent_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_rent_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'med_rent_single_us',
        },
      ],
    },
    {
      title: 'Median Home Value',
      graph: 'med_hom_val_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_hom_val_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_hom_val_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'med_hom_val_single_us',
        },
      ],
    },
    {
      title: 'Vacancy Rate',
      graph: 'hu_unocc_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hu_unocc_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hu_unocc_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hu_unocc_single_us',
        },
      ],
    },
    {
      title: 'Owner Occupancy Rate',
      graph: 'hu_own_occ_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hu_own_occ_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hu_own_occ_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hu_own_occ_single_us',
        },
      ],
    },
    {
      label: 'Socioeconomics & Demographics',
      type: 'TITLE',
      newPage: true,
    },
    {
      label: 'Census Comparison',
      type: 'CENSUS_COMPARISON_TABLE',
      table: 'place_impact_social_census_table',
      prepend,
    },
    {
      newPage: true,
      title: 'Social Vulnerability',
      graph: 'social_vulnerability_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Index Value',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'social_vulnerability_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'social_vulnerability_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'social_vulnerability_us',
        },
      ],
    },
    {
      title: 'Median Household Income',
      graph: 'med_hh_inc_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: 'Dollars',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'med_hh_inc_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'med_hh_inc_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'med_hh_inc_single_us',
        },
      ],
    },
    {
      title: 'Broadband Internet',
      graph: 'broadband_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'broadband_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'broadband_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'broadband_us',
        },
      ],
    },
    {
      title: 'Households with Computer(s)',
      graph: 'hh_w_comp_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hh_w_comp_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hh_w_comp_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hh_w_comp_us',
        },
      ],
    },
    {
      title: 'Poverty Rate',
      graph: 'pov_pct_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'pov_pct_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'pov_pct_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'pov_pct_single_us',
        },
      ],
    },
    {
      title: "Bachelor's Degree Holder Rate",
      graph: 'ed_ba_plus_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_ba_plus_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_ba_plus_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_ba_plus_single_us',
        },
      ],
    },
    {
      title: 'Households with Children Under 18',
      graph: 'hh_w_kids_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hh_w_kids_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hh_w_kids_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hh_w_kids_single_us',
        },
      ],
    },
    {
      title: '% of Population Hispanic or Latino (of any race)',
      graph: 'hispanic_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'hispanic_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'hispanic_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'hispanic_us',
        },
      ],
    },
    {
      title: '% of Population White',
      graph: 'rc_white_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_white_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_white_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_white_single_us',
        },
      ],
    },
    {
      title: '% of Population Black or African American',
      graph: 'rc_afam_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_afam_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_afam_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_afam_single_us',
        },
      ],
    },
    {
      title: '% of Population American Indian or Alaska Native',
      graph: 'rc_natv_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_natv_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_natv_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_natv_single_us',
        },
      ],
    },
    {
      title: '% of Population Asian',
      graph: 'rc_asian_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_asian_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_asian_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_asian_single_us',
        },
      ],
    },
    {
      title: '% of Population Native Hawaiian or Other Pacific Islander',
      graph: 'rc_islnd_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_islnd_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_islnd_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_islnd_single_us',
        },
      ],
    },
    {
      title: '% of Population Other Race',
      graph: 'rc_other_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_other_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_other_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_other_single_us',
        },
      ],
    },
    {
      title: '% of Population Two or More Races',
      graph: 'rc_2p_single_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'rc_2p_single_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'rc_2p_single_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'rc_2p_single_us',
        },
      ],
    },

    {
      label: 'Education',
      type: 'TITLE',
      newPage: true,
    },
    {
      label: 'Census Comparison',
      type: 'CENSUS_COMPARISON_TABLE',
      table: 'place_impact_education_census_table',
      prepend,
    },
    {
      title: 'High school graduate (includes equivalency)',
      graph: 'ed_hs_plus_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_hs_plus_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_hs_plus_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_hs_plus_us',
        },
      ],
    },
    {
      title: 'Associate\'s degree',
      graph: 'ed_assoc_plus_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_assoc_plus_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_assoc_plus_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_assoc_plus_us',
        },
      ],
    },
    {
      title: 'Bachelor\'s degree',
      graph: 'ed_ba_plus_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_ba_plus_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_ba_plus_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_ba_plus_us',
        },
      ],
    },
    {
      title: 'Graduate or professional degree',
      graph: 'ed_doc_plus_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_doc_plus_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_doc_plus_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_doc_plus_us',
        },
      ],
    },
    {
      title: 'Nursery school, preschool (%)',
      graph: 'enroll_preschool_pct_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'enroll_preschool_pct_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'enroll_preschool_pct_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'enroll_preschool_pct_us',
        },
      ],
    },

    {
      label: 'Economic',
      type: 'TITLE',
      newPage: true,
    },
    {
      label: 'Census Comparison',
      type: 'CENSUS_COMPARISON_TABLE',
      table: 'place_impact_economic_census_table',
      prepend,
    },
    {
      title: 'High school graduate (includes equivalency)',
      graph: 'ed_hs_plus_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: false,
      after: 2011,
      label: 'Block Group',
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ed_hs_plus_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ed_hs_plus_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ed_hs_plus_us',
        },
      ],
    },

    {
      title: 'Employed',
      graph: 'emp_pct_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'emp_pct_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'emp_pct_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'emp_pct_us',
        },
      ],
    },
    {
      title: 'Unemployed',
      graph: 'unemp_pct_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'unemp_pct_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'unemp_pct_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'unemp_pct_us',
        },
      ],
    },
    {
      title: 'Agriculture, forestry, fishing and hunting, and mining',
      graph: 'ind_agff_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_agff_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_agff_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_agff_us',
        },
      ],
    },
    {
      title: 'Construction',
      graph: 'ind_construction_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_construction_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_construction_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_construction_us',
        },
      ],
    },
    {
      title: 'Manufacturing',
      graph: 'ind_manufacture_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_manufacture_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_manufacture_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_manufacture_us',
        },
      ],
    },
    {
      title: 'Wholesale trade',
      graph: 'ind_wholesale_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_wholesale_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_wholesale_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_wholesale_us',
        },
      ],
    },
    {
      title: 'Retail trade',
      graph: 'ind_retail_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_retail_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_retail_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_retail_us',
        },
      ],
    },
    {
      title: 'Transportation and warehousing, and utilities',
      graph: 'ind_trans_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_trans_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_trans_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_trans_us',
        },
      ],
    },
    {
      title: 'Information',
      graph: 'ind_info_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_info_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_info_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_info_us',
        },
      ],
    },
    {
      title: 'Finance and insurance, and real estate and rental and leasing',
      graph: 'ind_finance_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_finance_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_finance_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_finance_us',
        },
      ],
    },
    {
      title: 'Professional, scientific, and management, and administrative and ',
      graph: 'ind_pro_science_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_pro_science_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_pro_science_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_pro_science_us',
        },
      ],
    },
    {
      title: 'Educational services, and health care and social assistance',
      graph: 'ind_ed_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_ed_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_ed_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_ed_us',
        },
      ],
    },
    {
      title: 'Arts, entertainment, and recreation, and accommodation and food services',
      graph: 'ind_art_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_art_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_art_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_art_us',
        },
      ],
    },
    {
      title: 'Other services, except public administration',
      graph: 'ind_other_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_other_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_other_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_other_us',
        },
      ],
    },
    {
      title: 'Public administration',
      graph: 'ind_public_fips',
      type: 'COMPARISON_LINE_GRAPH',
      useRatio: true,
      unit: '%',
      compare: [
        {
          to: 'COUNTY',
          useFilters: true,
          graph: 'ind_public_concat_state_county',
        },
        {
          to: 'STATE',
          useFilters: true,
          graph: 'ind_public_state',
        },
        {
          to: 'COUNTRY',
          label: 'USA',
          useFilters: true,
          graph: 'ind_public_us',
        },
      ],
    },

    {
      label: 'Neighborhood Revitalization',
      type: 'TITLE',
      newPage: true,
    },
    {
      column: 'rehab_impact_pred',
      label: 'Predicted Rehabilitation Impact',
      filterString: 'is_latest=1',
      type: 'DOLLARS',
      default: 0,
      method: 'avg',
    },

    {
      column: 'demo_impact_pred',
      label: 'Predicted Demolition Impact',
      filterString: 'is_latest=1',
      type: 'DOLLARS',
      default: 0,
      method: 'avg',
    },
    {
      column: 'homes_impacted',
      label: 'Predicted # of Homes Impacted',
      filterString: 'is_latest=1',
      type: 'NUMBER',
      default: 0,
      method: 'avg',
    },
  ].filter(({
    column,
    graph,
    label,
  }) => !exclude.includes(column) && !exclude.includes(label) && !exclude.includes(graph));
};
